import React from 'react';
import { Check } from 'lucide-react';

const OrderProgress = ({ status, timestamps }) => {
  const steps = ['pending', 'processing', 'shipped', 'delivered'];
  const currentStep = steps.indexOf(status);

  return (
    <div className="relative">
      <div className="flex justify-between mb-2">
        {steps.map((step, index) => {
          const isCompleted = index <= currentStep;
          const isCurrent = index === currentStep;

          return (
            <div key={step} className="flex flex-col items-center flex-1">
              <div
                className={`
                w-8 h-8 rounded-full flex items-center justify-center
                ${isCompleted ? 'bg-primary white-text' : 'bg-gray-200'}
                ${isCurrent ? 'ring-2 ring-primary ring-offset-2' : ''}
              `}
              >
                {isCompleted ? <Check size={16} /> : index + 1}
              </div>
              <div className="text-xs mt-1 capitalize">{step}</div>
              {timestamps && timestamps[step] && (
                <div className="text-xs text-gray-500">
                  {new Date(timestamps[step]).toLocaleDateString()}
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div className="absolute top-4 left-0 right-0 h-0.5 -z-10">
        <div className="h-full bg-gray-200" />
        <div
          className="h-full bg-primary transition-all duration-300"
          style={{ width: `${(currentStep / (steps.length - 1)) * 100}%` }}
        />
      </div>
    </div>
  );
};

export default OrderProgress;
